<template>
    <div class="content">

      <!--<div v-if="!paymentType" style="text-align: center;">
         <el-button type="warning" @click="paymentBtn">微信/支付宝支付</el-button>
         <br>
         <br><br><br><br>
         <el-button type="danger" @click="paymentType=true">蓝新支付</el-button>
      </div>-->
      <!--<div v-if="paymentType">-->
      <div>
        <div style="padding-top: 20px;"></div>
      
        <div style="display: none;"></div>
        <div ref="alipayWeb" v-html="alipay" style="display: none;"></div>
        <div class="form-class">

            <div style="text-align: center;">
              <h1>{{ server_name }}</h1>
              <p style="color: red;">充值比例：1 : {{ scale }}</p>
            </div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="账号" prop="game_account_name">
                    <el-input v-model="ruleForm.game_account_name"></el-input> 
                </el-form-item>
                <el-form-item label="确认账号" prop="agin_game_account_name">
                    <el-input v-model="ruleForm.agin_game_account_name"></el-input>     
                </el-form-item>
                <el-form-item label="金额" prop="amt">
                    <el-input-number v-model="ruleForm.amt" :min="4" :max="100000000" :step="4"></el-input-number>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="ruleForm.remark" type="textarea"  :rows="2"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
                </el-form-item>
            </el-form>

        </div>
      </div>

    </div>
</template>
<script>
import {Form, Message} from 'element-ui';
  export default {
    data() {
      return {
        ruleForm: {
          remark:'',
          agin_game_account_name:'',
          game_account_name:'',
          amt:0
        },
        paymentType:false,
        payBtn:false,
        tip:'请扫码支付',
        tipFlag:true,
        options:[],
        scale : 1,
        orderNo:'',
        server_name:'',
        alipay:'',
        out_pay_url:'',
        rules: {
          amt: [
            { required: true, message: '请填写金额', trigger: 'blur' },
            
          ],
          game_account_name: [
            { required: true, message: '请输入游戏账号', trigger: 'blur' },
          ],
          agin_game_account_name: [
            { required: true, message: '请输入确认游戏账号', trigger: 'blur' },
          ],
        }
      };
    },
    created(){
      this.getParam();


      //const appSecret = process.env.VUE_APP_SECRET;
      //console.log('appSecret:',appSecret)
    //  this.getParam();
   /* let self = this
    self.postRequest('/admin/login',self.ruleForm).then(resp =>{
                 self.payBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.alipay = resp.data;
                 console.log(resp.data);
                 self.$nextTick(()=>{
                      self.$refs.alipayWeb.children[0].submit();
                  });
             

            })*/

    },
    methods: {
      paymentBtn(){
        window.open(this.out_pay_url, "_blank");

       // window.location.href= "http://app.sxzbd.com/pay/tbNg";
      },
      submitForm(formName) {
        let self = this;
       
        if(self.ruleForm.agin_game_account_name == self.ruleForm.game_account_name){
          self.payBtn = true;
          self.$refs[formName].validate((valid) => {
          if (valid) {
            self.postRequest('/bluenew/pay',self.ruleForm).then(resp =>{
                 self.payBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.alipay = resp.data;
                 console.log(resp.data);
                 self.$nextTick(()=>{
                      self.$refs.alipayWeb.children[0].submit();
                  });
             

            })
          } else {
            self.payBtn=false;
            console.log('error submit!!');
            return false;
          }
        });
        }else{
          self.$message({
          showClose: true,
          message: '两次输入的账号不一致',
          type: 'error'
        });
        }
      },
      getParam(){
        console.log("getParam,,,,,,,,,,,,,,");
        let self = this;
        var url = window.location.href ;             //获取当前url
        var dz_url = url.split('#')[0];                //获取#/之前的字符串
        var csstr = dz_url.split('?')[1];                //获取?之后的参数字符串
        var cs_arr = csstr.split('&');                    //参数字符串分割为数组
        var cs={};
        for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
            cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
        }
        self.ruleForm.serviceId = cs.service_id;                                           //这样就拿到了参数中的数据
        console.log("this.ruleForm.service_id:"+self.ruleForm.service_id);

        self.postRequest('/game/servers_detail',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.serverDetail = resp.data;
                self.out_pay_url = resp.data.out_pay_url;
                document.title = resp.data.service_name;
                self.server_name = resp.data.service_name;
            })

       

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      
  
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    },
  }
</script>
<style scoped>
    .title-class{
        padding-left: 140px;
        padding-top: 30px;
    }
    .get-role{
        margin-left: 10px;
    }
    .content{
        margin: 0 auto;
        margin-top: 50px;
        align-content: center;
        width: 50%;
        height: 600px;
        max-height: 800px;
        background-color: rgb(161, 194, 203);
        border-radius: 20px;
    }
    .form-class{
        padding-top: 20px;
        padding-left: 90px;
        width: 60%;
    }

</style>